<div [formGroupName]="formGroupName()" class="d-flex flex-column">
  <p class="fw-bold">{{ 'user_edit_overview_l' | translate }}: {{ label() | translate }}</p>

  <div class="mb-3 d-flex flex-column flex-sm-row gap-3">
    <im-form-field>
      <label class="im:floating-label">
        <span floatingLabel>{{ 'user_phone_edit_country_code_label_l' | translate }}</span>
        <input
          minlength="3"
          maxlength="4"
          type="text"
          class="im:input"
          id="country-code"
          formControlName="countryCode"
          [placeholder]="'user_phone_edit_country_code_placeholder_l' | translate"
        />
      </label>
    </im-form-field>

    <im-form-field>
      <label class="im:floating-label">
        <span floatingLabel>{{ 'user_phone_edit_prefix_l' | translate }}</span>
        <input
          type="text"
          class="im:input"
          id="prefix"
          formControlName="prefix"
          [placeholder]="'user_phone_edit_prefix_l' | translate"
        />
      </label>
    </im-form-field>

    <im-form-field>
      <label class="im:floating-label">
        <span floatingLabel>{{ 'user_phone_edit_number_l' | translate }}</span>
        <input
          type="text"
          class="im:input"
          id="number"
          formControlName="phoneNumber"
          [placeholder]="'user_phone_edit_number_l' | translate"
        />
      </label>
    </im-form-field>
  </div>
</div>
